module.exports = __webpack_public_path__ + "img/eat_out_01.eb60bdef.jpg";